import { FilterChip, Flex, Text } from 'pcln-design-system'
import React, { memo } from 'react'
import { TIME_ICONS, DEFAULT_TIME_ICONS } from '../constants'
import { timeChipClickHandler } from '../helpers'
import { getFilterId } from '../../helpers'
import PCLNAnalytics from '@pcln/analytics'

const TimeChips = (props) => {
  const { entity = '', activeTimes, sliceRefId, timebands } = props

  const containerId = `time-chip-container-${entity}`

  try {
    return (
      <Flex flexWrap='wrap' mb='24px' aria-label={containerId} data-testid={containerId} width={'auto'} p={1}>
        {
          // Paint the chips here using the data returend from the API call
          timebands.map(({ icon, label, timeRange, disable }, index) => {
            const id = `${entity}-${label}-${index}`

            const timeIcon = TIME_ICONS?.[icon] || DEFAULT_TIME_ICONS[index]

            // "id" has a purpose, so we separate id from testId
            const testId = getFilterId('time', index, id)
            return (
              <FilterChip
                width={1}
                key={id}
                id={id}
                onClick={() =>
                  timeChipClickHandler({
                    disable,
                    activeTimes,
                    entity,
                    label,
                    sliceRefId,
                    ...props,
                  })
                }
                selected={activeTimes?.[`${entity}`]?.includes(label)}
                disabled={disable}
                aria-label={`time-filter-chip-${id}`}
                data-testid={testId}
                m={'8px'}
                ml={'0px'}
                mb={'4px'}
                mt={index !== 0 ? 1 : 0}
              >
                <Flex
                  width={1}
                  m={2}
                  alignItems='center'
                  display={'flex'}
                  testId='testinggg'
                  pt={'0px'}
                  pb={'0px'}
                >
                  <Flex data-testid={id + `-icon-wrapper`} pr={1}>
                    {timeIcon}
                  </Flex>

                  <Text data-testid={testId + `-text`} fontSize={0} regular mr={'0px'}>
                    {label}
                  </Text>
                  <Text data-testid={testId + `-time-range`} fontSize={0} regular ml={'auto'}>
                    {timeRange}
                  </Text>
                </Flex>
              </FilterChip>
            )
          })
        }
      </Flex>
    )
  } catch (e) {
    PCLNAnalytics.logError({
      errorObject: e,
      message: 'Render Failure - File: TimeChips.js: ' + e.stack,
      type: 'TimeChips.js',
    })
    return null
  }
}

export default memo(TimeChips)
